;(() => {
    const focusedClass = 'control-wrapper--focused'
    const hoveredClass = 'control-wrapper--hovered'
    const errorClass = 'control-wrapper--error'
    const outlinedlass = 'control-wrapper--outlined'

    const collection = document.querySelectorAll('.control-wrapper')

    Array.from(collection).forEach(el => {
        if (!el) return
        const input = el.querySelector('.input')


        if (el.classList.contains(outlinedlass)) {
            el.addEventListener('mouseover', () => el.classList.add(hoveredClass))
            el.addEventListener('mouseout', () => el.classList.remove(hoveredClass))

            if (input) {
                input.addEventListener('focus', () => el.classList.add(focusedClass))
                input.addEventListener('blur', () => el.classList.remove(focusedClass))
            }
        }

        if (input) {
            input.addEventListener('input', () => el.classList.remove(errorClass))
        }
        // input.addEventListener('change', () => el.classList.remove(errorClass))
    })
})()
